export type WaapiErrorCode = 'SIN_LICENCIA' | 'TELEFONO_INVALIDO' | 'URL_INVALIDA' | 'SIN_SESION'

/** Error de validación previo al envío (el backend no se llama) */
export class WaapiError extends Error {
  code: WaapiErrorCode
  constructor(code: WaapiErrorCode, message: string) {
    super(message)
    this.name = 'WaapiError'
    this.code = code
  }
}

export const WAAPI_MENSAJE_SIN_LICENCIA =
  'El comercio no tiene una licencia de WhatsApp vigente. Solicítela a su proveedor.'

/** URL descargable por el servicio de WhatsApp (no blob: ni data:) */
export const esUrlPublicaWaapi = (url?: string | null): url is string => /^https?:\/\//i.test(url ?? '')
